import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import InsuranceCaseInformation from '../../../PatientDetails/InsuranceCaseInformation'
import { savePatientDetails } from '../../../../../redux/sidePanel/sidePanelThunk'

export default function PanelPatientInsuranceCase() {
  const dispatch = useDispatch()
  const panelEncounter = useSelector((state) => state.sidePanel.panelEncounter)

  return (
    <div id={'PanelPatientInsuranceCase'}>
      <div className={'display-box'}>
        <InsuranceCaseInformation
          patient={panelEncounter}
          onRefreshPatient={() => {
            dispatch(savePatientDetails({}))
          }}
        />
      </div>
    </div>
  )
}
